import React from 'react';

export default function LoadingSpinner({ isGlobal = true }) {
  return (
    <div className={isGlobal ? 'global-loader' : 'local-loader'}>
      <div className="whirly-loader"></div>
    </div>
  );
}
